import { render, staticRenderFns } from "./BotFlowriskmanagement.vue?vue&type=template&id=15fc87bf"
import script from "./BotFlowriskmanagement.vue?vue&type=script&lang=js"
export * from "./BotFlowriskmanagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports